module.exports = __webpack_public_path__ + "static/media/chargeads.d4117e26.pdf";